import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('send_approvalmax_events_to_xero'),
    subtitle: defineMessage('choose_which_events_tha_approval_of_the_request'),
    optionNoneText: defineMessage('dont_send_events_to_xero'),
    optionCommentsText: defineMessage('send_only_comments'),
    optionAllText: defineMessage('send_all_events'),
};
